import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { shareReplay, switchMap, take } from 'rxjs/operators';
import { FeatureGroup, FeatureToggle, UserFeatureGroup } from '../models/feature-toggle.model';

@Injectable({
    providedIn: 'root',
})
export class FeatureTogglesService {
    private readonly INTERVAL: number = 60 * 1000;
    private readonly baseUrl = '/api/user_service/feature-toggles';
    private userFeatureToggles$$: Observable<Map<string, boolean>>;

    constructor(protected http: HttpClient) {
        this.initUserFeatureToggles();
    }

    private initUserFeatureToggles() {
        this.userFeatureToggles$$ = timer(0, this.INTERVAL).pipe(
            switchMap(() => {
                return this.http.get<Map<string, boolean>>(`${this.baseUrl}/users/current`);
            }),
            shareReplay({ refCount: false, bufferSize: 1 }),
        );
    }

    saveUserFeatureGroup$(userId: string, group: FeatureGroup): Observable<Object> {
        return this.http.post(`${this.baseUrl}/users/${userId}?group=${group}`, null);
    }

    getAllFeatureToggles$(): Observable<FeatureToggle[]> {
        return this.http.get<FeatureToggle[]>(this.baseUrl);
    }

    getAllUserGroups$(): Observable<UserFeatureGroup[]> {
        return this.http.get<UserFeatureGroup[]>(`${this.baseUrl}/users`);
    }

    getUserFeatureToggles$(): Observable<Map<string, boolean>> {
        return this.userFeatureToggles$$.pipe(take(1));
    }
}
